import { ProjectSetup } from './../models/project-setup.model';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-setups',
  templateUrl: './project-setups.component.html',
  styleUrls: ['./project-setups.component.scss'],
  standalone: false,
})
export class ProjectSetupsComponent implements OnInit {
  inProcessProjectSetups: ProjectSetup[];
  powerPlanProjectSetups: ProjectSetup[];
  sentProjectSetups: ProjectSetup[];

  ngOnInit() {
    this.getProjectSetups();
  }

  getProjectSetups() {
    this.inProcessProjectSetups = [
      {
        businessUnit: '1234',
        fundingProjectID: '000000003',
        chargingProjectID: '000000000',
        chargingProjectName: 'Project name short description',
        lastSavedDate: new Date(2020, 11, 3, 15, 20),
      },
      {
        businessUnit: '1234',
        fundingProjectID: '000000004',
        chargingProjectID: '000000000',
        chargingProjectName: 'Project name short description',
        lastSavedDate: new Date(2020, 11, 1, 11, 4),
      },
    ];

    this.powerPlanProjectSetups = [
      {
        businessUnit: '1234',
        fundingProjectID: '000000003',
        chargingProjectID: '000000000',
        chargingProjectName: 'Project name short description',
        lastSavedDate: new Date(2020, 11, 3, 15, 20),
      },
      {
        businessUnit: '1234',
        fundingProjectID: '000000004',
        chargingProjectID: '000000000',
        chargingProjectName: 'Project name short description',
        lastSavedDate: new Date(2020, 11, 1, 11, 4),
      },
      {
        businessUnit: '1234',
        fundingProjectID: '000000004',
        chargingProjectID: '000000000',
        chargingProjectName: 'Project name short description',
        lastSavedDate: new Date(2020, 11, 1, 11, 4),
      },
      {
        businessUnit: '1234',
        fundingProjectID: '000000004',
        chargingProjectID: '000000000',
        chargingProjectName: 'Project name short description',
        lastSavedDate: new Date(2020, 11, 1, 11, 4),
      },
    ];
  }

  formatDate(date: Date) {
    let rawHours = date.getHours();
    let hours: number;
    if (rawHours === 0) {
      hours = 12;
    } else if (rawHours > 12) {
      hours = rawHours - 12;
    } else {
      hours = rawHours;
    }
    let rawMinutes = date.getMinutes();
    let minutes = rawMinutes.toString().padStart(2, '0');
    let AMOrPM;
    if (rawHours < 12) {
      AMOrPM = 'AM';
    } else {
      AMOrPM = 'PM';
    }
    let rawMonth = date.getMonth();
    let month = (rawMonth + 1).toString().padStart(2, '0');
    let rawDay = date.getDate();
    let day = rawDay.toString().padStart(2, '0');
    let year = date.getFullYear();
    return hours + ':' + minutes + AMOrPM + ' on ' + month + '/' + day + '/' + year;
  }
}
